var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27461_4277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0251 8.70635C15.4343 8.31572 15.4343 7.68135 15.0251 7.29072L9.78702 2.29072C9.37779 1.9001 8.71321 1.9001 8.30398 2.29072C7.89476 2.68135 7.89476 3.31572 8.30398 3.70635L11.7579 7.0001L1.7138 7.0001C1.13434 7.0001 0.666184 7.44697 0.666184 8.0001C0.666184 8.55322 1.13434 9.0001 1.7138 9.0001L11.7546 9.0001L8.30725 12.2938C7.89803 12.6845 7.89803 13.3188 8.30725 13.7095C8.71648 14.1001 9.38106 14.1001 9.79029 13.7095L15.0284 8.70947L15.0251 8.70635Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27461_4277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 16,
    fill: "white",
    transform: "translate(15.332 16) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.930722ac50d3f57562aba0afcc0051c7.svg";
export { ForwardRef as ReactComponent };